import React from "react";

function Energy() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#fdbf00"
        d="M360.7 252.7c1.201 4.799-.3 10.199-4.2 13.799L256 367l-49.501 49.499c-5.099 5.4-13.2 6-19.199 1.8-6-4.499-8.101-12.299-4.801-18.9l52.2-104.7-73.499-24.6c-4.801-1.5-8.701-5.7-9.901-10.8-1.201-4.799.3-10.201 4.2-13.801l150-150c5.099-5.4 13.2-5.999 19.199-1.8 6 4.501 8.101 12.301 4.801 18.9l-52.2 104.7 73.499 24.6c4.802 1.501 8.702 5.701 9.902 10.802z"
        data-original="#fdbf00"
      ></path>
      <path
        fill="#54e360"
        d="M512 256c0 8.399-6.599 15-15 15s-15-6.601-15-15c0-124.2-101.8-226-226-226-72.001 0-140.2 35.799-182.199 92.8l30.298-1.8c8.101-.3 15.3 5.7 15.901 14.099.601 8.101-5.7 15.3-14.099 15.901l-60 3.6C37.5 155.2 30 147.4 30 139.6V76c0-8.401 6.599-15 15-15s15 6.599 15 15v16.5C107.999 35.499 179.801 0 256 0c140.7 0 256 115.3 256 256zm-30 116.4V436c0 8.399-6.599 15-15 15s-15-6.601-15-15v-16.5C404.001 476.499 332.199 512 256 512 115.3 512 0 396.7 0 256c0-8.401 6.599-15 15-15s15 6.599 15 15c0 124.2 101.8 226 226 226 72.001 0 140.2-35.801 182.199-92.8l-30.298 1.8c-8.101.599-15.3-5.7-15.901-14.101-.601-8.099 5.7-15.3 14.099-15.899l60-3.6c8.101-.6 15.901 6.599 15.901 15z"
        data-original="#54e360"
      ></path>
      <path
        fill="#ff9f00"
        d="M356.499 266.499L256 367V145l49.501-49.501c5.099-5.4 13.2-5.999 19.199-1.8 6 4.501 8.101 12.301 4.801 18.9l-52.2 104.7 73.499 24.6c4.801 1.5 8.701 5.7 9.901 10.801 1.2 4.8-.302 10.199-4.202 13.799z"
        data-original="#ff9f00"
      ></path>
      <path
        fill="#00cc71"
        d="M482 372.4V436c0 8.399-6.599 15-15 15s-15-6.601-15-15v-16.5C404.001 476.499 332.199 512 256 512v-30c72.001 0 140.2-35.801 182.199-92.8l-30.298 1.8c-8.101.599-15.3-5.7-15.901-14.101-.601-8.099 5.7-15.3 14.099-15.899l60-3.6c8.101-.6 15.901 6.599 15.901 15zM512 256c0 8.399-6.599 15-15 15s-15-6.601-15-15c0-124.2-101.8-226-226-226V0c140.7 0 256 115.3 256 256z"
        data-original="#00cc71"
      ></path>
    </svg>
  );
}

export default Energy;
